import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    IGetServiceIdsErrorAction,
    IGetServicesIdsAction,
    IGetServiceIdsSuccessAction,
} from '../actions/service-ids/get-service-ids';
import { IStoreIntState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadServiceIdsAction
    = IGetServiceIdsErrorAction
    | IGetServicesIdsAction
    | IGetServiceIdsSuccessAction;

const init = (state: IStoreIntState, action: LoadServiceIdsAction) => {
    return ({
        ...state,
        serviceIdsOptions : {
            ...state.serviceIdsOptions,
            status: action.status
        }
    });
} 

const success = (state: IStoreIntState, action: LoadServiceIdsAction) => ({
    ...state,
    serviceIdsOptions: {
        status: action.status,
        data: (action as IGetServiceIdsSuccessAction).data
    }
});

const failure = (state: IStoreIntState, action: LoadServiceIdsAction) => ({
    ...state,
    serviceIdsOptions: {
        ...initialState.serviceIdsOptions,
        status: action.status,
        error: (action as IGetServiceIdsErrorAction).error
    }
});

export const loadServiceIdsReducer = createAsyncReducer(initialState, init, success, failure);